export const STORE_TYPES = {
  AUTH: "auth",
  AUTH_USER: "authUser",
  HELPERS: "helpers",
  COURSES: "courses",
  LECTURER_COURSES: "lecturerCourses",
  MEDIA: "media",
  LAST_VIDEOS: "lastVideos",
  SLIDES: "slides",
  NOTES: "notes",
  CERTIFICATES: "certificates",
};

export const HELPER_TYPES = {
  /*** GETTERS  ***/
  GET_IS_SIDEBAR_ACTIVE: "GET_IS_SIDEBAR_ACTIVE",
  GET_LOADING_IDS: "GET_LOADING_IDS",
  GET_ERROR_IDS: "GET_ERROR_IDS",
  GET_TOAST_MESSAGE: "GET_TOAST_MESSAGE",

  /*** MUTATIONS  ***/
  SET_IS_SIDEBAR_ACTIVE: "SET_IS_SIDEBAR_ACTIVE",
  SET_LOADING_IDS: "SET_LOADING_IDS",
  SET_LOADING_ID: "SET_LOADING_ID",
  REMOVE_LOADING_ID: "REMOVE_LOADING_ID",
  SET_ERROR_IDS: "SET_ERROR_IDS",
  SET_ERROR_ID_OBJECT: "SET_ERROR_ID_OBJECT",
  REMOVE_ERROR_ID: "REMOVE_ERROR_ID",
  SET_TOAST_MESSAGE: "SET_TOAST_MESSAGE",
  /*** ACTIONS  ***/
  RESET_DATA: "RESET_DATA",
};

export const AUTH_TYPES = {
  /*** GETTERS  ***/
  IS_LOGGED_IN: "IS_LOGGED_IN",
  /*** MUTATIONS  ***/

  /*** ACTIONS  ***/
  LOGIN: "LOGIN",
  LOGIN_WITH_TOKEN: "LOGIN_WITH_TOKEN",
  LOGOUT: "LOGOUT",
  RESET_PASSWORD: "RESET_PASSWORD",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
};
export const AUTH_USER_TYPES = {
  /*** GETTERS  ***/
  GET_USER: "GET_USER",
  /*** MUTATIONS  ***/
  SET_USER: "SET_USER",
  /*** ACTIONS  ***/
  FETCH_USER: "FETCH_USER",
  UPDATE_USER: "UPDATE_USER",
};
export const COURSE_TYPES = {
  /*** GETTERS  ***/
  GET_COURSES: "GET_COURSES",
  GET_COURSE: "GET_COURSE",
  GET_SELECTED_COURSE_TYPE: "GET_SELECTED_COURSE_TYPE",
  GET_SHOW_DOCUMENTS: "GET_SHOW_DOCUMENTS",

  /*** MUTATIONS  ***/
  SET_COURSES: "SET_COURSES",
  SET_COURSE: "SET_COURSE",
  SET_SELECTED_COURSE_TYPE: "SET_SELECTED_COURSE_TYPE",
  SET_SHOW_DOCUMENTS: "SET_SHOW_DOCUMENTS",
  RESET_STATE: "RESET_STATE",

  /*** ACTIONS  ***/
  FETCH_COURSES: "FETCH_COURSES",
  FETCH_COURSE: "FETCH_COURSE",
  VALIDATE_REVIEW: "VALIDATE_REVIEW",
  UPDATE_CUSTOMER_REVIEWS: "UPDATE_CUSTOMER_REVIEWS",
  UPLOAD_COURSE_WORKBOOK: "UPLOAD_COURSE_WORKBOOK",
  UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
};
export const LECTURER_TYPES = {
  /*** GETTERS  ***/
  GET_COURSES: "GET_COURSES",
  GET_PARTICIPANTS: "GET_PARTICIPANTS",
  GET_PARTICIPANT: "GET_PARTICIPANT",

  /*** MUTATIONS  ***/
  SET_COURSES: "SET_COURSES",
  SET_PARTICIPANTS: "SET_PARTICIPANTS",
  SET_PARTICIPANT: "SET_PARTICIPANT",

  /*** ACTIONS  ***/
  FETCH_COURSES: "FETCH_COURSES",
  FETCH_PARTICIPANTS: "FETCH_PARTICIPANTS",
  FETCH_PARTICIPANT: "FETCH_PARTICIPANT",
  UPDATE_PARTICIPANT_EXAM_STATUS: "UPDATE_PARTICIPANT_EXAM_STATUS",
};
export const MEDIA_TYPES = {
  /*** GETTERS  ***/
  GET_MATERIALS: "GET_MATERIALS",
  /*** MUTATIONS  ***/
  SET_MATERIALS: "SET_MATERIALS",
  /*** ACTIONS  ***/
  FETCH_MATERIALS: "FETCH_MATERIALS",
  FETCH_MEDIA_AS_BASE: "FETCH_MEDIA_AS_BASE",
  UPLOAD_AVATAR: "UPLOAD_AVATAR",
  OPEN_MEDIA_IN_NEW_TAB: "OPEN_MEDIA_IN_NEW_TAB",
  DOWNLOAD_MEDIA: "DOWNLOAD_MEDIA",
};
export const LAST_VIDEOS_TYPES = {
  /*** GETTERS  ***/
  GET_LAST_VIDEOS: "GET_LAST_VIDEOS",
  /*** MUTATIONS  ***/
  SET_LAST_VIDEOS: "SET_LAST_VIDEOS",
  /*** ACTIONS  ***/
  FETCH_LAST_VIDEOS: "FETCH_LAST_VIDEOS",
};
export const SLIDE_TYPES = {
  /*** GETTERS  ***/
  GET_SLIDE: "GET_SLIDE",
  /*** MUTATIONS  ***/
  SET_SLIDE: "SET_SLIDE",
  /*** ACTIONS  ***/
  UPDATE_MANUAL: "UPDATE_MANUAL",
  UPDATE_SLIDE_PROGRESS: "UPDATE_SLIDE_PROGRESS",
  UPDATE_TEST_QUESTIONS: "UPDATE_TEST_QUESTIONS",
};
export const NOTE_TYPES = {
  /*** GETTERS  ***/
  GET_NOTES: "GET_NOTES",
  /*** MUTATIONS  ***/
  SET_NOTES: "SET_NOTES",
  /*** ACTIONS  ***/
  FETCH_NOTES: "FETCH_NOTES",
  CREATE_NOTE: "CREATE_NOTE",
  DELETE_NOTE: "DELETE_NOTE",
  UPDATE_NOTE: "UPDATE_NOTE",
};
export const CERTIFICATE_TYPES = {
  /*** GETTERS  ***/
  GET_CERTIFICATE: "GET_CERTIFICATE",
  GET_COUPONS: "GET_COUPONS",
  GET_COURSE_COUPON: "GET_COURSE_COUPON",
  /*** MUTATIONS  ***/
  SET_CERTIFICATE: "SET_CERTIFICATE",
  SET_COUPONS: "SET_COUPONS",
  SET_COURSE_COUPON: "SET_COURSE_COUPON",
  /*** ACTIONS  ***/
  FETCH_CERTIFICATE: "FETCH_CERTIFICATE",
  FETCH_COUPONS: "FETCH_COUPONS",
  DOWNLOAD_CERTIFICATE: "DOWNLOAD_CERTIFICATE",
  FETCH_COURSE_COUPON: "FETCH_COURSE_COUPON",
};
